export declare interface ApiMusicSourceAddressAssignment {
  AddressDomain: string;
  AddressUsername: string;
  MusicSourceId: string;
  MusicSourceName: string;
  MusicSourceUrl: string;
}

export declare interface MusicSourceAddressAssignment {
  addressDomain: string;
  addressUsername: string;
  musicSourceId: string;
  musicSourceName: string;
  musicSourceUrl: string;
}

export function apiMusicSourceAddressAssignmentToMusicSourceAddressAssignment(
  apiMusicSource: ApiMusicSourceAddressAssignment
) {
  return {
    addressDomain: apiMusicSource.AddressDomain,
    addressUsername: apiMusicSource.AddressUsername,
    musicSourceId: apiMusicSource.MusicSourceId,
    musicSourceName: apiMusicSource.MusicSourceName,
    musicSourceUrl: apiMusicSource.MusicSourceUrl
  };
}
